import React from 'react';
import { Rocket, Globe, Home, FileCheck, ArrowRight } from 'lucide-react';
import { quickActions } from '../mock';

const iconMap = {
  Rocket: Rocket,
  Globe: Globe,
  Home: Home,
  FileCheck: FileCheck
};

const QuickActionSection = () => {
  const scrollToSection = (link) => {
    const id = link.replace('#', '');
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative bg-white py-20">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-4 tracking-tight">
            How Can We Help You Today?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Quick solutions for common business challenges
          </p>
        </div>

        {/* Quick Action Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {quickActions.map((action) => {
            const IconComponent = iconMap[action.icon];
            return (
              <div 
                key={action.id}
                onClick={() => scrollToSection(action.link)}
                className="group bg-gradient-to-br from-[#0099FF]/5 to-transparent border border-gray-200 p-6 hover:border-[#0099FF] hover:shadow-xl transition-all duration-400 cursor-pointer"
              >
                {/* Icon */}
                <div className="w-12 h-12 bg-[#0099FF]/10 flex items-center justify-center mb-4 group-hover:bg-[#0099FF] group-hover:scale-110 transition-all duration-400">
                  <IconComponent className="text-[#0099FF] group-hover:text-white transition-colors duration-400" size={24} />
                </div>

                {/* Title */}
                <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-[#0099FF] transition-colors duration-300">
                  {action.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  {action.description}
                </p>

                {/* Link */}
                <div className="flex items-center gap-2 text-[#0099FF] text-sm font-medium opacity-0 group-hover:opacity-100 transition-all duration-400">
                  <span>Know More</span>
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default QuickActionSection;
